import { FormElement } from '@progress/kendo-react-form';
import { SchedulerForm } from '@progress/kendo-react-scheduler';
import * as React from 'react';
import { CustomDialog } from './custom-dialog';
import { CustomFormEditor } from './custom-form-editor';
import { useEffect } from 'react';
import { useState } from 'react';
import * as Toasts from '../../../common/Toastify';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const FormWithCustomEditor = (props) => {
  const [showEmptySchedular,setShowEmptySchedular] = useState(false);
  // const selectedAuthUsers = useSelector(store => store.jobOpportunity.selectedAuthUsers)
  const showDailyCalendar = useSelector(store => store.jobOpportunity.showDailyCalendar)
  const location = useLocation();
  const pathName = location?.pathname;
  const requiredValidator = React.useCallback(
    (value) =>
      value === undefined || value === null || value === ''
        ? 'Field is required.'
        : undefined,
    []
  );
  const dateValidator = React.useCallback((value) => 
    value < new Date() ? "Please select future Date and Time":""
  ,[])
  const dateComapre = React.useCallback((startDate,endDate) => 
  startDate > endDate ? "Shift end time should not be lesser than Shift start time":""
,[])
  const formValidator = (_dataItem, formValueGetter) => {
    let result = {};
    result.Start = dateValidator(formValueGetter('Start'))
    result.End = dateComapre(formValueGetter('Start'),formValueGetter('End'))
    result.AppointmentType = [
      requiredValidator(formValueGetter('AppointmentType')),
    ]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, '');
    result.ShiftLength = [requiredValidator(formValueGetter('ShiftLength'))]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, '');
    result.PatientName = [requiredValidator(formValueGetter('PatientName'))]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, '');
    result.PatientPhone = [requiredValidator(formValueGetter('PatientPhone'))]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, '');
    result.PatientStreetAddress = [
      requiredValidator(formValueGetter('PatientStreetAddress')),
    ]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, '');
    result.PatientZipCode = [
      requiredValidator(formValueGetter('PatientZipCode')),
    ]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, '');
    result.PatientState = [requiredValidator(formValueGetter('PatientState'))]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, '');
    result.PatientCity = [requiredValidator(formValueGetter('PatientCity'))]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, '');
    result.billingRate = [requiredValidator(formValueGetter('billingRate'))]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, '');
    return result;
  };
useEffect(() => {
  if(props?.dataItem?.Start){
    if(props?.dataItem?.Start < new Date()){
      Toasts.warning("Please select future Date and Time");
      setShowEmptySchedular(true)
    }
    if(pathName === "/daily-encounter-info" && ( props?.dataItem?.candidateUniqueId === "0" || !props?.dataItem?.candidateUniqueId)){
      Toasts.warning("You can't create an occurrence under the unassigned, please select the authorized candidate.");
      setShowEmptySchedular(true)
    } 
  }
  // if(selectedAuthUsers?.length <= 0) {
  //   Toasts.warning("Please select Authorized User");
  //   setShowEmptySchedular(true)
  // }
},[props?.dataItem?.Start, showDailyCalendar ]) 
// , selectedAuthUsers?.length
useEffect(() => {
  if(pathName !== "/daily-encounter-info" && !showDailyCalendar ) {
    Toasts.warning("Please click 'Get Schedule' button after selecting candidates to create appointments");
    setShowEmptySchedular(true)
  }
  return () => {
    setShowEmptySchedular(false)
  }
},[props?.dataItem?.Start ])
  return (
   <>
   {
    showEmptySchedular ? null :<SchedulerForm
    {...props}
    editor={CustomFormEditor}
    // dialog={CustomDialog}
    validator={formValidator}
  />  
   }
   </>
  );
};
